import React from "react";
import {
    OrderOverviewPageContent
} from "@shopcrate/shopcrate-framework";

import Helmet from "../../../components/Helmet";

import bannerImage from "../../../img/top_10_kantoorplanten.jpg";

function OrderOverview() {
    return (
        <React.Fragment>
            <Helmet title="Overzicht"/>
            <div className="jumbotron jumbotron-fluid jumbotron-header jumbotron-sm" style={ { backgroundImage: "url(" + bannerImage + ")" } }>
                <div className="container">
                    <h1 className="text-white">Overzicht</h1>
                </div>
            </div>
            <div className="container mb-5">
                <OrderOverviewPageContent/>
            </div>
        </React.Fragment>
    );
}

export default React.memo(OrderOverview);
